import React, { useEffect, useState } from "react";
import "./navbar.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Notify from "../popup/Notify";
import Exammenu from "../../components/nav/Exammenu";
import moblogo from "../../images/green-logo.png";
import { IoIosNotificationsOutline, IoIosPerson } from "react-icons/io";
import Dropdown from "react-bootstrap/Dropdown";
import { GrFormClose } from "react-icons/gr";
import MobNav from "../Mobnav/MobNav";
import Loginstd from "../Studdrop/Loginstd";
import Register from "../Studdrop/Register";
import FeedBack from "../../components/popup/FeedBack";
import { Form } from "react-bootstrap";
import { baseUrl } from "../../context/BaseUrl";
import axios from "axios";
import Suggestion from "../popup/Suggestion";
const logoD = require("../../images/logo.png");
const logoM = require("../../images/sidebarlogo1.png");
// import Offcanvas from 'react-bootstrap/Offcanvas';

const Navbar = (props) => {
  const [showNotification, setShowNotification] = useState(false);
  const [feed, setFeed] = useState(false);
  const [Data, setData] = useState(null);  
  const [show, setShow] = useState(false);
  const [active, setActive] = useState('unactive');
  const [activeL, setActiveL] = useState('unactive');
  const [activeR, setActiveR] = useState('unactive');
  const handleNotify = () => setShowNotification(!showNotification);

  const val = localStorage.getItem("user");
  const user = JSON.parse(val);
  if (user) {
    // console.log("________user________", user);

    // console.log(user.user._id);
    var id = user.user._id;
  }

  const navigate = useNavigate();

  const DelToken = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  const handleActive = () => {
    active == 'unactive' ?  setActive('active') : setActive('unactive')
  }
  const handleActiveL = () => {
    activeL == 'unactive' ?  setActiveL('active') : setActiveL('unactive')
  }
  const handleActiveR = () => {
    activeR == 'unactive' ?  setActiveR('active') : setActiveR('unactive')
  }

  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  async function fetchData() {
    try {
      const response = await axios.get(
        `${baseUrl}/user/category/getcategory_details`
      );
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);
  const handleShow = () => setShow(true);


  return Data && (
    <React.Fragment>
    {/* <MobNav /> */}
    <div className="menu" id="navbar">
        <header id="topnav" className="defaultscroll scroll-active">
          <div
            className="offcanvas offcanvas-start shadow-sm"
            style={{ width: "75%" }}
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasRightLabel">
                <div className="logo">
                  <NavLink to="/">
                    <img src={logoM} alt="moblogo" />
                  </NavLink>
                </div>
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <NavLink
                to="/"
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                Home
              </NavLink>
              <div
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                <span onClick={handleActive} className={`nav_sm_exam cursor-pointer nav-link-lg me-5 text-decoration-none ${active}`}>
                Exams
              </span>

              <ul className={`submenu nav_sm_exam_sub ${active}`}>
                {Data.map((item, index) => (
                  <li key={index}>
                    <NavLink
                      to={`/exams/${item.category_name.replace(" ","-")}/${item._id}`}
                      variant="primary"
                      className="nav-link-lg me-5 text-decoration-none register"
                    >
                      {item.category_name}
                    </NavLink>
                  </li>
                ))}
              </ul>
              </div>
              {/* <NavLink
                to=" "
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                Institutes
              </NavLink> */}
              <NavLink
                to=" "
                onClick={handleShow}
                className="nav-link-offcanvas  text-decoration-none d-block"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Suggestions
              </NavLink>
              <Suggestion handle={{ show, setShow }} />
              <NavLink
              onClick={() => setFeed(true)}
                to=""
                className="nav-link-offcanvas  text-decoration-none d-block"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Write a Review
              </NavLink>
              <FeedBack handle={{ feed, setFeed }} />
              {/* <NavLink
                to=""
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                Careers
              </NavLink> */}
              {/* <NavLink
                to="/listing"
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                Listing
              </NavLink> */}
              <NavLink
                to="/vacancy"
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
               All vacancy
              </NavLink>

              <div className="divider-heading">My Account</div>
              <div className="divider-line"></div>
              {user ? (
                <React.Fragment>
                  <NavLink
                    to={`/profile/${id}`}
                    className="nav-link-offcanvas  text-decoration-none d-block"
                  >
                    Profile
                  </NavLink>
                  <NavLink
                    to={`/saved/${id}`}
                    className="nav-link-offcanvas  text-decoration-none d-block"
                  >
                    Saved 
                  </NavLink>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {/* <NavLink
                    to="/student-login"
                    className="nav-link-offcanvas  text-decoration-none d-block"
                  >
                    Login
                  </NavLink> */}
                  <div
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                <span onClick={handleActiveL} className={`nav_sm_exam cursor-pointer nav-link-lg me-5 text-decoration-none ${activeL}`}>
                Login
              </span>

              <ul className={`submenu nav_sm_exam_sub ${activeL}`}>
                  <li>
                    <NavLink
                      to="/student-login"
                      variant="primary"
                      className="nav-link-lg me-5 text-decoration-none register"
                    >
                      Login as Student
                    </NavLink>
                  </li>
                  <li>
                  <a href="https://obepedia-institute.netlify.app" className="">Login as Institute </a>
                  </li>
              </ul>
              </div>
              <div
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                <span onClick={handleActiveR} className={`nav_sm_exam cursor-pointer nav-link-lg me-5 text-decoration-none ${activeR}`}>
                Register
              </span>

              <ul className={`submenu nav_sm_exam_sub ${activeR}`}>
                  <li>
                    <NavLink
                      to="/student-register"
                      variant="primary"
                      className="nav-link-lg me-5 text-decoration-none register"
                    >
                      Register as Student
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/student-register"
                      variant="primary"
                      className="nav-link-lg me-5 text-decoration-none register"
                    >
                      Register as Institute
                    </NavLink>
                  </li>
              </ul>
              </div>
                  {/* <NavLink
                    to="/student-register"
                    className="nav-link-offcanvas  text-decoration-none d-block"
                  >
                    Register
                  </NavLink> */}
                </React.Fragment>
              )}
              {/* <div className="divider-line"></div> */}
              {/* <NavLink
                to="#"
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                About us
              </NavLink>
              <NavLink
                to=" "
                className="nav-link-offcanvas  text-decoration-none d-block"
              >
                Contact us
              </NavLink> */}
              {user ? (
                <React.Fragment>
                  <button className="signout" onClick={() => DelToken()}>
                    Signout
                  </button>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="header-top">
            {/* <div className="container"> */}
            <div className="header">
              <div className="navbar d-flex justify-content-between align-item-center px-2 py-0">
                <button
                  className="menu d-lg-none d-md-flex btn border-0"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                >
                  <div className="sandwich top rounded-pill me-auto"></div>
                  <div className="sandwich middle rounded-pill me-auto"></div>
                  <div className="sandwich bottom rounded-pill me-auto"></div>
                </button>
                <div className="logo d-none d-md-flex d-lg-none">
                    <NavLink to="/" className="logo">
                      <img
                        src={logoD}
                        alt="logo"
                        className={`logo homepage`}
                      />
                    </NavLink>
                  </div>
                  {user ? (
                    <div className="right auth-menu-right d-none d-md-inline-block d-lg-none">
                      <div className="logged-person">
                        <Dropdown className="nav-link-lg me-4 text-decoration-none d-none d-md-inline-block d-lg-none">
                          <Dropdown.Toggle>
                            {user.user.name[0].toUpperCase()}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item>
                              <Link to={`/profile/${id}`} className="w-100">
                                Profile
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link to={`/saved/${id}`} className="w-100">
                                Saved
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link to="/" onClick={() => DelToken()}>
                                Sign out
                              </Link>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  ) : (
                    <div className="right auth-menu-right  d-none d-md-inline-block d-lg-none">
                    
                      {props.loginpage ? (
                        <div className=""></div>
                      ) : (
                        <Loginstd />
                      )}
                    </div>
                  )}
                <div
                  className={`d-flex justify-content-between align-items-center navmenu homepage`}
                  style={{ width: "calc(100%)" }}
                >
                  <div className="logo d-flex">
                    <NavLink to="/" className="logo">
                      <img
                        src={logoD}
                        alt="logo"
                        className={`logo homepage`}
                      />
                    </NavLink>
                  </div>
                  <div className="center exam-menu-center">
                    <Exammenu home={props.home} />
                  </div>

                  {user ? (
                    <div className="right auth-menu-right">
                      <div className="logged-person">
                        <IoIosNotificationsOutline onClick={handleNotify} />

                        <Dropdown className="nav-link-lg me-4 text-decoration-none d-none d-lg-inline-block">
                          <Dropdown.Toggle>
                            {user.user.name[0].toUpperCase()}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item>
                              <Link to={`/profile/${id}`} className="w-100">
                                Profile
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link to={`/saved/${id}`} className="w-100">
                                Saved
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link to="/" onClick={() => DelToken()}>
                                Sign out
                              </Link>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  ) : (
                    <div className="right auth-menu-right">
                    
                      {props.loginpage ? (
                        <div className=""></div>
                      ) : (
                        <Loginstd />
                      )}
                    </div>
                  )}

                  
                </div>
              </div>
            </div>

            {/* </div> */}
          </div>
        </header>
      </div>
      <Notify handle={{showNotification, setShowNotification}} />
      {/* header end */}
    </React.Fragment>
  );
};

export default Navbar;
































// import React, { useState } from "react";
// import "./navbar.css";
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import Notify from "../popup/Notify";
// import Exammenu from "../../components/nav/Exammenu";
// import moblogo from "../../images/green-logo.png";
// import { IoIosNotificationsOutline, IoIosPerson } from "react-icons/io";
// import Dropdown from "react-bootstrap/Dropdown";
// import { GrFormClose } from "react-icons/gr";
// import MobNav from "../Mobnav/MobNav";
// import Loginstd from "../Studdrop/Loginstd";
// import Register from "../Studdrop/Register";
// import { Form } from "react-bootstrap";
// const logoD = require("../../images/logo.png");
// const logoM = require("../../images/sidebarlogo1.png");
// // import Offcanvas from 'react-bootstrap/Offcanvas';

// const Navbar = (props) => {
//   const [showNotification, setShowNotification] = useState(false);
//   const handleNotify = () => setShowNotification(!showNotification);

//   const val = localStorage.getItem("user");
//   const user = JSON.parse(val);
//   if (user) {
//     var id = user.user._id;
//   }

//   const navigate = useNavigate();

//   const DelToken = () => {
//     localStorage.removeItem("user");
//     navigate("/");
//   };

//   // const [show, setShow] = useState(false);

//   // const handleClose = () => setShow(false);
//   // const handleShow = () => setShow(true);

//   return (
//     <React.Fragment>
//     <MobNav />
//     <div className="menu" id="navbar">
//         <header id="topnav" className="defaultscroll scroll-active">
//           <div
//             className="offcanvas offcanvas-start shadow-sm"
//             style={{ width: "75%" }}
//             id="offcanvasRight"
//             aria-labelledby="offcanvasRightLabel"
//           >
//             <div className="offcanvas-header">
//               <h5 className="offcanvas-title" id="offcanvasRightLabel">
//                 <div className="logo">
//                   <NavLink to="/">
//                     <img src={logoM} alt="moblogo" />
//                   </NavLink>
//                 </div>
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="offcanvas"
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="offcanvas-body">
//               <NavLink
//                 to="/"
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Home
//               </NavLink>
//               <NavLink
//                 to="/upsc"
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Exams
//               </NavLink>
//               <NavLink
//                 to=" "
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Institutes
//               </NavLink>
//               <NavLink
//                 to=" "
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Suggestions
//               </NavLink>
//               <NavLink
//                 to=" "
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Write a Review
//               </NavLink>
//               <NavLink
//                 to=""
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Careers
//               </NavLink>
//               <NavLink
//                 to="/listing"
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Listing
//               </NavLink>
//               <NavLink
//                 to="/vacancy"
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 vacancy
//               </NavLink>

//               <div className="divider-heading">My Account</div>
//               <div className="divider-line"></div>
//               {user ? (
//                 <React.Fragment>
//                   <NavLink
//                     to={`/profile/${id}`}
//                     className="nav-link-offcanvas  text-decoration-none d-block"
//                   >
//                     Profile
//                   </NavLink>
//                   <NavLink
//                     to={`/saved/${id}`}
//                     className="nav-link-offcanvas  text-decoration-none d-block"
//                   >
//                     Saved Institute
//                   </NavLink>
//                 </React.Fragment>
//               ) : (
//                 <React.Fragment>
//                   <NavLink
//                     to="/student-login"
//                     className="nav-link-offcanvas  text-decoration-none d-block"
//                   >
//                     Login
//                   </NavLink>
//                   <NavLink
//                     to="/student-register"
//                     className="nav-link-offcanvas  text-decoration-none d-block"
//                   >
//                     Register
//                   </NavLink>
//                 </React.Fragment>
//               )}
//               <div className="divider-line"></div>
//               <NavLink
//                 to="#"
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 About us
//               </NavLink>
//               <NavLink
//                 to=" "
//                 className="nav-link-offcanvas  text-decoration-none d-block"
//               >
//                 Contact us
//               </NavLink>
//               {user ? (
//                 <React.Fragment>
//                   <button className="signout" onClick={() => DelToken()}>
//                     Signout
//                   </button>
//                 </React.Fragment>
//               ) : (
//                 ""
//               )}
//             </div>
//           </div>

//           <div className="header-top">
//             {/* <div className="container"> */}
//             <div className="header">
//               <div className="navbar d-flex justify-content-between align-item-center px-2 py-0">
//                 <button
//                   className="menu d-lg-none d-flex btn border-0"
//                   data-bs-toggle="offcanvas"
//                   data-bs-target="#offcanvasRight"
//                   aria-controls="offcanvasRight"
//                 >
//                   <div className="sandwich top rounded-pill me-auto"></div>
//                   <div className="sandwich middle rounded-pill me-auto"></div>
//                   <div className="sandwich bottom rounded-pill me-auto"></div>
//                 </button>
//                 {/* <div className={`logo ${props.home == 'homepage' ? "d-none" : 'd-flex'}`}>
//                   <NavLink to="/" className="logo">
//                     <img src={logoD} alt="logo" />
//                   </NavLink>
//                 </div> */}

//                 <div
//                   className={`d-flex justify-content-between align-items-center navmenu homepage`}
//                   style={{ width: "calc(100%)" }}
//                 >
//                   <div className="logo d-flex">
//                     <NavLink to="/" className="logo">
//                       <img
//                         src={logoD}
//                         alt="logo"
//                         className={`logo homepage`}
//                       />
//                     </NavLink>
//                   </div>
//                   <div className="center exam-menu-center">
//                     <Exammenu home={props.home} />
//                   </div>

//                   {user ? (
//                     <div className="right auth-menu-right">
//                       <div className="logged-person">
//                         <IoIosNotificationsOutline onClick={handleNotify} />

//                         <Dropdown className="nav-link-lg me-4 text-decoration-none d-none d-lg-inline-block">
//                           <Dropdown.Toggle>
//                             {user.user.name[0].toUpperCase()}
//                           </Dropdown.Toggle>

//                           <Dropdown.Menu>
//                             <Dropdown.Item>
//                               <Link to={`/profile/${id}`} className="w-100">
//                                 Profile
//                               </Link>
//                             </Dropdown.Item>
//                             <Dropdown.Item>
//                               <Link to={`/saved/${id}`} className="w-100">
//                                 Saved
//                               </Link>
//                             </Dropdown.Item>
//                             <Dropdown.Item>
//                               <Link to="/" onClick={() => DelToken()}>
//                                 Sign out
//                               </Link>
//                             </Dropdown.Item>
//                           </Dropdown.Menu>
//                         </Dropdown>
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="right auth-menu-right">
//                       {/* <div className="login">
//                                                 <Loginstd />
//                                             </div>

//                                             <div className="register nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block">
//                                                <button className='started'> Get Started</button>
//                                             </div> */}
//                       {props.loginpage ? (
//                         <div className=""></div>
//                       ) : (
//                         <Loginstd />
//                       )}
//                     </div>
//                   )}

//                   {/* <div className="logged-person">
//                                         <IoIosNotificationsOutline />
//                                         <Dropdown className="nav-link-lg me-4 text-decoration-none d-none d-lg-inline-block">
//                                             <Dropdown.Toggle >
//                                                 P
//                                             </Dropdown.Toggle>

//                                             <Dropdown.Menu>
//                                                 <Dropdown.Item><Link to={`/profile/${id}`}> Profile </Link>  </Dropdown.Item>
//                                                 <Dropdown.Item> <Link to='/reviews'> Reviews </Link>   </Dropdown.Item>
//                                                 <Dropdown.Item><Link to={`/saved/${id}`}> Saved Institutes </Link> </Dropdown.Item>
//                                                 <Dropdown.Item><Link to='/followed'> Followed Institutes </Link> </Dropdown.Item>
//                                                 <Dropdown.Item><Link to='/' onClick={() => DelToken()} > Sign out </Link> </Dropdown.Item>
//                                             </Dropdown.Menu>
//                                         </Dropdown>
//                                     </div> */}
//                 </div>
//               </div>
//             </div>

//             {/* </div> */}
//           </div>
//         </header>
//       </div>
//       <Notify handle={{showNotification, setShowNotification}} />
//       {/* header end */}
//     </React.Fragment>
//   );
// };

// export default Navbar;
